import isNull from 'lodash/isNull';
import { CategoryFilterValue } from '~/types/category';
import { IJsonAPIFilterBuilder } from './jsonapi-query';

export const addCategoryFilter = (
  filterBuilder: IJsonAPIFilterBuilder,
  category: CategoryFilterValue | null,
  categoryParam = 'category.id',
  subcategoryParam = 'subcategory.id',
) => {
  if (!isNull(category)) {
    if (category.type === 'uncategorized') {
      filterBuilder.empty(categoryParam, true);
      filterBuilder.empty(subcategoryParam, true);
    } else if (category.type === 'categories') {
      filterBuilder.in(categoryParam, category.categoryId);
    } else if (category.type === 'category_without_subcategories') {
      filterBuilder.eq(categoryParam, category.categoryId);
      filterBuilder.empty(subcategoryParam, true);
    } else {
      filterBuilder.eq(categoryParam, category.categoryId);
      filterBuilder.in(subcategoryParam, category.subcategoryId);
    }
  }
  return filterBuilder;
};
